// extracted by mini-css-extract-plugin
module.exports = {"mygraph":"BarGraph_mygraph__3Cz73"};